// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PREPROD,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PREPROD,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PREPROD,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PREPROD,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PREPROD,
    appId: process.env.REACT_APP_FIREBASE_APP_ID_PREPROD,
  };